<template>
    <div class="slide">

        <go-back />

        <div class="slide-container">

            <div class="question">
                Would you like to enter <span>additional incomes</span>?
            </div>

            <div class="answer answer-col answers-centered">
                <span class="alternative" @click="next('yes')">Yes</span>
                <span class="alternative" @click="next('no')">No</span>
            </div>

        </div>

    </div>
</template>

<script>
import GoBack from "./GoBack";

export default {
    name: 'AdditionalIncome',
    components: {
        GoBack
    },
    methods: {
        next( haveOtherIncome ) {
            if ( haveOtherIncome === 'yes' ) {
                this.$router.push({ name: 'Income' });
            } else {
                this.$router.push({ name: 'HaveSavings' });
            }
        }
    }
}
</script>